<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M11.5 4.5C11.5 5.32843 10.8284 6 10 6C9.17157 6 8.5 5.32843 8.5 4.5C8.5 3.67157 9.17157 3 10 3C10.8284 3 11.5 3.67157 11.5 4.5Z"
            fill="currentColor"
        />
        <path
            d="M11 9C11 8.44772 10.5523 8 10 8C9.44772 8 9 8.44772 9 9V16C9 16.5523 9.44772 17 10 17C10.5523 17 11 16.5523 11 16V9Z"
            fill="currentColor"
        />
    </svg>
</template>
